import { __decorate } from "tslib";
import { ArrayDecoder, field, StringDecoder } from "@simonbackx/simple-encoding";
import { BalanceItem, BalanceItemPayment, MemberBalanceItemPayment } from "./BalanceItem";
import { Member } from "./members/Member";
import { Registration } from "./members/Registration";
import { Order } from "./webshops/Order";
export class BalanceItemDetailed extends BalanceItem {
    constructor() {
        super(...arguments);
        this.registration = null;
        this.member = null;
        this.order = null;
    }
    get memberId() {
        var _a, _b;
        return (_b = (_a = this.member) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : null;
    }
}
__decorate([
    field({ decoder: Registration, nullable: true })
], BalanceItemDetailed.prototype, "registration", void 0);
__decorate([
    field({ decoder: Member, nullable: true })
], BalanceItemDetailed.prototype, "member", void 0);
__decorate([
    field({ decoder: Order, nullable: true })
], BalanceItemDetailed.prototype, "order", void 0);
export class BalanceItemPaymentDetailed extends BalanceItemPayment {
}
__decorate([
    field({ decoder: BalanceItemDetailed })
], BalanceItemPaymentDetailed.prototype, "balanceItem", void 0);
export class MemberBalanceItem extends BalanceItem {
    constructor() {
        super(...arguments);
        this.payments = [];
        this.memberId = null;
        this.userId = null;
        this.registration = null;
        this.order = null;
    }
    /**
     * Return whether a payment has been initiated for this balance item
     */
    get hasPendingPayment() {
        return !!this.payments.find(p => p.payment.isPending);
    }
    static getOutstandingBalance(items) {
        // Get sum of balance payments
        const totalPending = items.flatMap(b => b.payments).filter(p => p.payment.isPending).map(p => p.price).reduce((t, total) => total + t, 0);
        const total = items.map(p => p.price - p.pricePaid).reduce((t, total) => total + t, 0);
        const totalOpen = total - totalPending;
        return {
            totalPending, // Pending payment
            totalOpen, // Not yet started
            total: totalPending + totalOpen // total not yet paid
        };
    }
}
__decorate([
    field({ decoder: new ArrayDecoder(MemberBalanceItemPayment) })
], MemberBalanceItem.prototype, "payments", void 0);
__decorate([
    field({ decoder: StringDecoder, nullable: true })
], MemberBalanceItem.prototype, "memberId", void 0);
__decorate([
    field({ decoder: StringDecoder, nullable: true })
], MemberBalanceItem.prototype, "userId", void 0);
__decorate([
    field({ decoder: Registration, nullable: true })
], MemberBalanceItem.prototype, "registration", void 0);
__decorate([
    field({ decoder: Order, nullable: true })
], MemberBalanceItem.prototype, "order", void 0);
//# sourceMappingURL=BalanceItemDetailed.js.map